import Dexie, { Table } from 'dexie';
import { Conversation, Message } from '../models/chat';

export class ChatDatabase extends Dexie {
  conversations!: Table<Conversation, number>;
  messages!: Table<Message, number>;

  constructor() {
    super('ChatDB');
    this.version(3).stores({
      conversations: 'id, type, unreadCount, ownerId',
      messages:
        'id, conversationId, createdAt, sender.id, ownerId, [conversationId+ownerId]',
    });
  }
}

export const chatDb = new ChatDatabase();
